<template>
  <div class="quantity quantity-default" size>
    <Inputs v-model="currentValue" class="choose-item " :readonly="readonly" :size="size"  :disabled="disabled" @on-blur="handleBlur" @on-focus="handleFocus">
      <div slot="prepend" class="am-link am-no-select" @click="disabled ||--currentValue" v-if="!prepend">
        -
      </div>
      <div slot="append" class="am-link am-no-select" @click="disabled ||++currentValue" v-if="!append">
        +
      </div>
    </Inputs>
  </div>
</template>

<script>
  import Inputs from './../Input/index'
  import { oneOf } from './../assist'
  export default {
    props: {
      min: {
        type: [ Number, String ],
        default: 0
      },
      max: {
        type: [ Number, String ]
      },
      value: {
        type: [ Number,String ],
        default: 0
      },
      readonly: {
        type: Boolean,
        default: false
      },
      size: {
        validator (value) {
          return oneOf(value, ['small', 'large', 'middle', 'default']);
        },
        default () {
          return 'default'
        }
      },
      prepend: {
        type: [Boolean],
        default: false
      },
      append: {
        type: [Boolean],
        default: false
      },
      disabled: {
        type: [Boolean],
        default: false
      }
    },
    created() {
    },
    data() {
      return {
        currentValue: this.value
      }
    },
    mounted() {
      this.handleChange()
    },
    computed: {},
    methods: {
      handleChange () {
        //改变产品数量
        let num  = this.currentValue,
          { max, min, disabled } = this,
          isAccord = true;
        if (disabled) return;
        if (!/^(0|[1-9][0-9]*)$/.test(num)) {
          if (Number(num)<0) {
            num = 0
          } else {
            num += ''
            num = num.replace(/^0*/, '').replace(/[^\d]*/g, '').replace('/\.\w*/', '') || 0
          }
          isAccord = false
        }
        if ((min|| min == 0)&&num<min) {
          num = min;
          isAccord = false
        }
        if ((max||max === 0)&&max<num) {
          num = max;
          isAccord = false;
          this.$emit('on-warning')
        }
        if (isAccord) {
          this.$emit('input', num);
          if (this.value != num) this.$emit('on-change', num)
        } else {
          this.$nextTick (() => {
            this.currentValue = num
          })
        }
      },
      handleBlur () {
        this.$emit('on-blur')
      },
      handleFocus () {
        this.$emit('on-focus')
      }
    },
    watch: {
      currentValue (n,o) {
        if (n === o) return;
        this.handleChange()
      },
      value (n, o) {
        if (n===o) return;
        this.currentValue = n
      }
    },
    components: {
      Inputs
      // Icon
    },
    destroyed() {
    }
  }
</script>

<style lang="less" scoped>
  .quantity {
    display: inline-block;
  }
  .am-link {
    font-size: 16px;

  }
</style>



// WEBPACK FOOTER //
// components/InputQuantity/InputQuantity.vue